
const configGooglePay = function() {
	try {
		if ('undefined' !== typeof braintree && 'undefined' !== typeof google && 'undefined' !== typeof google.payments) {
			let paymentsClient = new google.payments.api.PaymentsClient({
				environment: isProduction ? 'PRODUCTION' : 'TEST',
				paymentDataCallbacks: {
					onPaymentAuthorized: onPaymentAuthorized,
					onPaymentDataChanged: onPaymentDataChanged
				}
			});

			braintree.client.create({
				authorization: brainTreeAuthorizationToken
			}, function(clientErr, clientInstance) {
				braintree.googlePayment.create({
					client: clientInstance,
					googlePayVersion: 2,
					googleMerchantId: googleMerchantId
				}, function(googlePaymentErr, googlePaymentInstance) {
					let allowedPaymentMethodsTemp;

					if ('undefined' !== typeof googlePaymentInstance && googlePaymentInstance.createPaymentDataRequest()) {
						allowedPaymentMethodsTemp = googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods;
					} else {
						allowedPaymentMethodsTemp = [{
							"type": "CARD",
							"parameters": {
								"allowedAuthMethods": ["PAN_ONLY", "CRYPTOGRAM_3DS"],
								"allowedCardNetworks": ["AMEX", "DISCOVER", "JCB", "MASTERCARD", "VISA"]
							}
						}];
					}

					paymentsClient.isReadyToPay({
						apiVersion: 2,
						apiVersionMinor: 0,
						allowedPaymentMethods: allowedPaymentMethodsTemp,
						existingPaymentMethodRequired: true
					}).then(function(response) {
						if (response.result) {
							// add google pay button
							const googlePayContainers = document.getElementById('google-pay-button');

							if (null !== googlePayContainers) {
								const gButton = paymentsClient.createButton({
									buttonColor: isFromCheckout ? 'white' : 'default',
									buttonType: isFromCheckout ? 'short' : 'buy',
									buttonSizeMode: 'fill',
									onClick: () => {
										if (isFromCheckout) {
											ga('send', 'event', 'Checkout', 'Summary', 'Express Checkout button: Google Pay');
										} else {
											ga('send', 'event', 'Cart', 'Summary', 'Checkout button: Google Pay');
										}
									}
								});

								googlePayContainers.appendChild(gButton);

								// Add event listener to google-pay button.
								googlePayContainers.addEventListener('click', function(event) {
									event.preventDefault();
									let paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
										transactionInfo: getGoogleLineItems(),
										callbackIntents: ["SHIPPING_ADDRESS", "SHIPPING_OPTION", "PAYMENT_AUTHORIZATION"],
										shippingAddressRequired: true,
										shippingAddressParameters: {
											phoneNumberRequired: true
										},
										shippingOptionRequired: true,
										emailRequired: true
									});

									let cardPaymentMethod = paymentDataRequest.allowedPaymentMethods[0];

									cardPaymentMethod.parameters.billingAddressRequired = true;
									cardPaymentMethod.parameters.billingAddressParameters = {
										format: 'FULL',
										phoneNumberRequired: true
									};
									paymentsClient.loadPaymentData(paymentDataRequest)
										.then(function(paymentData) {
											return googlePaymentInstance.parseResponse(paymentData);
										}).then(function(result) {
									}).catch(function(err) {
										logError(err);
									});
								});
							}
						}
					}).catch(function(err) {
						logError(err);
					});
				});
			});
		}
	} catch (err) {
		$(".payment_method_radio.googlepay_bt").addClass('disable');
		logError(err);
	}
};

let shippingCost = [],
	lineItems = null;

const getGoogleLineItems = function(tax = null) {
	let price = $('.checkout-price').data('price') != undefined
		? parseFloat($('.checkout-price').data('price'))
		: parseFloat($('.summaryHead .subtotal').text().replace(/\$/g, ''));
	let taxAmount = (tax != null) ? tax : 0.00;

	lineItems = {
		displayItems: [
			{
				label: "Subtotal",
				type: "SUBTOTAL",
				price: price.toString(),
			},
			{
				label: "Tax",
				type: "TAX",
				price: taxAmount.toString(),
			}
		],
		countryCode: 'US',
		currencyCode: "USD",
		totalPriceStatus: "FINAL",
		totalPrice: (price + taxAmount).toString(),
		totalPriceLabel: "Total"
	};

	return lineItems;
};

const getGoogleUnserviceableAddressError = function(message) {
	return {
		reason: "SHIPPING_ADDRESS_UNSERVICEABLE",
		message: message,
		intent: "SHIPPING_ADDRESS"
	};
};

const getSonicShippingOptions = function(shippingMethod) {
	// clears previously set shipping option's cost
	shippingCost = [];

	let sonicShippingOptions = [];

	shippingMethod.forEach(method => {
		let methodObj = {
			"id": method.code,
			"label": method.label,
			"description": method.name
		};
		sonicShippingOptions.push(methodObj);
		shippingCost[method.code] = method.fee;
	});

	return {
		defaultSelectedOptionId: sonicShippingOptions[0].id,
		shippingOptions: sonicShippingOptions
	};
};

const calculateNewLineItemsInfo = function(shippingOptionId, tax = null) {
	// sales tax
	if (tax !== null) {
		// update tax value
		let taxObjIndex = lineItems.displayItems.findIndex((obj => obj.label == "Tax"));

		lineItems.displayItems[taxObjIndex].price = tax.toString();
	}

	// shipping cost
	let shippingCostObj = {
		type: "LINE_ITEM",
		label: "Shipping cost",
		price: shippingCost[shippingOptionId],
		status: "FINAL"
	};
	let shippingCostObjIndex = lineItems.displayItems.findIndex((obj => obj.label == "Shipping cost"));

	if (shippingCostObjIndex > -1) {
		// object for Shipping cost already exist, so update value for it
		lineItems.displayItems[shippingCostObjIndex] = shippingCostObj;
	} else {
		// object for Shipping cost is not exist, so add it
		lineItems.displayItems.push(shippingCostObj);
	}

	// total
	let totalPrice = 0.00;

	lineItems.displayItems.forEach(displayItem => totalPrice += parseFloat(displayItem.price));
	lineItems.totalPrice = totalPrice.toFixed(2).toString();

	return lineItems;
};

const onPaymentDataChanged = function(intermediatePaymentData) {
	let shippingAddress = intermediatePaymentData.shippingAddress;
	let shippingOptionData = intermediatePaymentData.shippingOptionData;
	let paymentDataRequestUpdate = {};

	if (intermediatePaymentData.callbackTrigger == "INITIALIZE" || intermediatePaymentData.callbackTrigger == "SHIPPING_ADDRESS") {
		return new Promise(function(resolve, reject) {
			$.ajax({
				dataType: 'json',
				type: 'POST',
				url: '/checkout/express/get-shipping-details',
				data: {
					'country': shippingAddress.countryCode,
					'zip': shippingAddress.postalCode,
					'address': shippingAddress.locality
				},
				error: function(err) {
					reject(err);
				},
				success: function(data) {
					if (data.success && data.shippingMethod.length > 0) {
						// shipping methods
						let shippingMethods = Object.values(JSON.parse(data.shippingMethod));

						if (shippingMethods.length > 0) {
							paymentDataRequestUpdate.newShippingOptionParameters = getSonicShippingOptions(shippingMethods);
							let selectedShippingOptionId = paymentDataRequestUpdate.newShippingOptionParameters.defaultSelectedOptionId;

							paymentDataRequestUpdate.newTransactionInfo = calculateNewLineItemsInfo(selectedShippingOptionId, data.taxValue);
						} else {
							paymentDataRequestUpdate.error = getGoogleUnserviceableAddressError("Please verify your zip/postal code as FedEx is not able to calculate a rate. ");
						}
					} else {
						// can't find shipping method for given address
						paymentDataRequestUpdate.error = getGoogleUnserviceableAddressError("Please verify your zip/postal code as FedEx is not able to calculate a rate. ");
					}
					resolve(paymentDataRequestUpdate);
				}
			});
		});
	} else if (intermediatePaymentData.callbackTrigger == "SHIPPING_OPTION") {
		return new Promise(function(resolve, reject) {
			paymentDataRequestUpdate.newTransactionInfo = calculateNewLineItemsInfo(shippingOptionData.id);
			resolve(paymentDataRequestUpdate);
		});
	}
};

const onPaymentAuthorized = function(paymentData) {
	return new Promise(function(resolve, reject) {
		processPayment(paymentData)
			.then((res) => {
				resolve({transactionState: 'SUCCESS'});
				window.location.href = res.redirect;
			})
			.catch((err) => {
				resolve({
					transactionState: 'ERROR',
					error: {
						intent: 'PAYMENT_AUTHORIZATION',
						message: err,
						reason: 'PAYMENT_DATA_INVALID'
					}
				});
			});
	});
};

const processPayment = function(paymentData) {
	let paymentToken = JSON.parse(paymentData.paymentMethodData.tokenizationData.token);

	return new Promise((resolve, reject) => {
		$.ajax({
			dataType: 'json',
			type: 'POST',
			url: '/checkout/express/update-google-pay-order',
			data: {
				'shippingAddress': paymentData.shippingAddress,
				'billingAddress': paymentData.paymentMethodData.info.billingAddress,
				'email': paymentData.email,
				'nonce': paymentToken.androidPayCards[0].nonce,
				'shippingMethod': paymentData.shippingOptionData['id'],
			},
			error: function(err) {
				reject(err);
			},
			success: function(data) {
				if (data.hasOwnProperty('success') && !data.success) {
					if (data.hasOwnProperty('errors')) {
						reject(data.errors);
					} else if (data.hasOwnProperty('alertMessage')) {
						reject(data.alertMessage);
					}
				}
				resolve(data);
			}
		});
	});
};

const logError = function(errorMessage) {
	let errorMsg = errorMessage.toString();

	errorMsg += '\nurl: ' + window.location.href;
	errorMsg += ('undefined' === typeof errorMessage.stack ? '' : '\nstack: ' + errorMessage.stack);
	if (window.hasOwnProperty('navigator')) {
		if (typeof window.navigator.userAgent !== 'undefined') {
			errorMsg += '\nuser agent: ' + window.navigator.userAgent;
		}
	}
	let formData = new FormData();

	formData.append('error', errorMsg);
	fetch('/javascript/error', {
		method: 'POST',
		body: formData
	});
};

export default configGooglePay;
